var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunitiesUnclicked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,23h-8v-8h8V23z M9,23H1v-8h8V23z M8,1h8v8H8V1z M19.5,14v-2.5h-7V10H17V0H7v10h4.5v1.5h-7V14H0v10h10V14 H5.5v-1.5h13V14H14v10h10V14H19.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunitiesUnclicked);
export default __webpack_public_path__ + "static/media/communities_unclicked.ee59b6cebead721085855c952e4d93ec.svg";
export { ForwardRef as ReactComponent };